import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import { EMAIL_CARD_OVERRIDES, EMAIL_CATEGORIES, EMAILS_CHANNELS_V2 } from '../constants'
import { WizardCategoryCardGrid } from '../WizardCategoryCard/WizardCategoryCard'
import { WizardButton, WizardCard } from '../WizardButton/WizardButton'
import { EmailCategories } from '../Types'

export const Emails = (props: SectionProps) => {
  const subCategory = props.subCategory as EmailCategories
  const setSubCategory = props.setSubCategory

  if (subCategory) {
    return (
      <div className={Styles.commonSectionContainer}>
        <WizardCategoryCardGrid heading={`What do you want to make?`}>
          {EMAILS_CHANNELS_V2[subCategory].map((channel) => (
            <WizardButton
              key={channel}
              channelKey={channel}
              version={2}
              size="lg"
              cardInfoOverride={EMAIL_CARD_OVERRIDES}
              {...props}
            />
          ))}
        </WizardCategoryCardGrid>
      </div>
    )
  }

  return (
    <div className={Styles.commonSectionContainer}>
      <WizardCategoryCardGrid heading="What kind of emails would you like to create?">
        {EMAIL_CATEGORIES.map((category) => (
          <WizardCard
            size="wide"
            key={category.name}
            title={category.label}
            description={category.description}
            image={category.image}
            onPress={() => setSubCategory(category.name)}
            {...props}
          />
        ))}
      </WizardCategoryCardGrid>
    </div>
  )
}
